import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { DateRangePipe } from './pipes/date-range.pipe';
import { PercentagePipe } from './pipes/percentage.pipe';
import { ToFormArrayPipe } from './pipes/to-form-array.pipe';
import { ToFormControlPipe } from './pipes/to-form-control.pipe';
import { ToFormGroupPipe } from './pipes/to-form-group.pipe';
import { ToPlainTextPipe } from './pipes/to-plain-text.pipe';

@NgModule({
  imports: [CommonModule, MatDialogModule],
  declarations: [DateRangePipe, PercentagePipe, ToFormArrayPipe, ToFormControlPipe, ToFormGroupPipe, ToPlainTextPipe],
  exports: [DateRangePipe, PercentagePipe, ToFormArrayPipe, ToFormControlPipe, ToFormGroupPipe, ToPlainTextPipe]
})
export class UtilsModule {}
